import { Route } from '@angular/router';
import { authGuard, authRoutes } from '@brightside/core/auth';
import { BrightnavRoutes } from '@brighthub/brightnav';
import { AskNaviRoutes } from '@brighthub/ask-navi';

export const appRoutes: Route[] = [
  authRoutes,
  ...AskNaviRoutes,
  ...BrightnavRoutes,
  {
    path: 'dashboard',
    redirectTo: '../brightnav',
  },
  {
    path: '**',
    pathMatch: 'prefix',
    redirectTo: 'brightnav',
  },
];
